import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Sector } from '../../../lib/models/fundamental/types';
import { getAllSectors } from '../../../lib/services/fundamental/helpers';
import { RootState } from '../../../lib/store';
import { getETFs, getSectors } from '../../../lib/store/fundamental';
import { DEFAULT_PAGE, GET_FIRST_ITEM_SIZE } from '../../../lib/store/fundamental/constants';
import { FundamentalCall } from '../../../lib/store/fundamental/types';
import { isCallStatusError, isCallStatusReady } from '../../../lib/util/error-handling/StatusByCallHelpers';

import ClickableDiv from '../../../components/ClickableDiv/ClickableDiv';
import { UI_ROUTES } from '../../../util/routes';
import { SECTORS_PER_ROW } from '../PopularGroups.constants';
import { NewOnThePopularGroupsData } from '../PopularGroups.types';

import groups from './groups';

import styles from './PopularGroupItems.module.scss';

const PopularGroupItems = () => {
  const sectors = useSelector<RootState, Sector[]>((state: RootState) => getAllSectors(state));
  const totalETFs = useSelector<RootState, number>((state: RootState) => state.fundamental.ETFData.totalElements);
  const isGetETFReady = useSelector<RootState, boolean>((state: RootState) => isCallStatusReady(
    FundamentalCall.getETFs,
    state.fundamental.statusByCall,
  ));
  const isGetETFError = useSelector<RootState, boolean>((state: RootState) => isCallStatusError(
    FundamentalCall.getETFs,
    state.fundamental.statusByCall,
  ));
  const isGetSectorReady = useSelector<RootState, boolean>((state: RootState) => isCallStatusReady(
    FundamentalCall.getSectors,
    state.fundamental.statusByCall,
  ));
  const isGetSectorError = useSelector<RootState, boolean>((state: RootState) => isCallStatusError(
    FundamentalCall.getSectors,
    state.fundamental.statusByCall,
  ));
  const isLoadingSectorOrETF:boolean = (!isGetETFReady && !isGetETFError) || (!isGetSectorReady && !isGetSectorError);
  const dispatch = useDispatch();
  const history = useHistory();

  let lengthGroupsRow = '';
  let renderGroups : NewOnThePopularGroupsData[] = [];

  useEffect(() => {
    dispatch(getETFs({ size: GET_FIRST_ITEM_SIZE, page: DEFAULT_PAGE }));
  }, []);// eslint-disable-line react-hooks/exhaustive-deps

  const renderGroup = (groupsData: NewOnThePopularGroupsData[], index: number) => {
    renderGroups = [];
    lengthGroupsRow = '';

    return (
      <div key={index}>
        <div className={styles.wrapperRowGroups}>
          {
            groupsData.map((group) => {
              const sectorName = group.sector.replace(/ /g, '');
              const groupValues = groups[sectorName];

              return (
                <ClickableDiv
                  key={group.id}
                  className={styles.group}
                  onClick={() => history.push({
                    pathname: `${UI_ROUTES.discover}${UI_ROUTES.popularGroup}/${group.sector}`,
                    state: { group, sector: groupValues.name },
                  })}
                >
                  <div>
                    <img className={styles.icon} src={groupValues.logo} alt="" />
                  </div>
                  <div className={styles.itemName}>
                    {groupValues.name}
                  </div>
                  <span className={styles.itemCount}>{`(${group.symbolCount})`}</span>
                </ClickableDiv>
              );
            })
         }
        </div>
      </div>
    );
  };

  useEffect(() => {
    dispatch(getSectors());
  }, [dispatch]);

  if (isLoadingSectorOrETF) {
    return (
      <div>
        <div className={styles.loaderRow}>
          <div className={styles.row} style={{ width: 255 }} />
          <div className={styles.row} style={{ width: 218 }} />
          <div className={styles.row} style={{ width: 310 }} />
        </div>
        <div className={styles.loaderRow}>
          <div className={styles.row} style={{ width: 221 }} />
          <div className={styles.row} style={{ width: 188 }} />
          <div className={styles.row} style={{ width: 266 }} />
        </div>
        <div className={styles.loaderRow}>
          <div className={styles.row} style={{ width: 264 }} />
          <div className={styles.row} style={{ width: 241 }} />
          <div className={styles.row} style={{ width: 218 }} />
        </div>
        <div className={styles.loaderRow}>
          <div className={styles.row} style={{ width: 213 }} />
          <div className={styles.row} style={{ width: 187 }} />
        </div>
      </div>
    );
  }

  const sortedSectors: NewOnThePopularGroupsData[] = [];

  Object.values(groups).forEach(group => {
    const findSector = sectors.find(sector => sector.sector === group.sectorName);
    findSector && sortedSectors.push(findSector);
  });

  return (
    <div className={styles.row}>
      {
          sortedSectors.map((item, index) => {
            lengthGroupsRow += item.sector;
            renderGroups.push(item);
            if (renderGroups.length === SECTORS_PER_ROW
                || index === sortedSectors.length - 1
            ) {
              return renderGroup(renderGroups, index);
            }
            return null;
          })
        }
    </div>
  );
};

export default PopularGroupItems;
